export const KEYS = {
  CLIENT_LOCATION: "/client-location",
  WALLET_LOCATION_EVENTS: "/wallet-location-events",
};
